module.exports = __webpack_public_path__ + "static/media/banner_large.91fe9fee.jpg";